const terminalStatuses = new Set(["已完成", "已取消"]);

const priorityOrder = {
  P0: 0,
  P1: 1,
  P2: 2,
  P3: 3,
  待确认: 4,
};

function dueTime(value) {
  if (!value) return Number.POSITIVE_INFINITY;
  const parsed = Date.parse(`${value}T00:00:00+08:00`);
  return Number.isNaN(parsed) ? Number.POSITIVE_INFINITY : parsed;
}

export function sortExecutionTasks(tasks = []) {
  return [...tasks].sort((a, b) => {
    const priorityDelta =
      (priorityOrder[a.priority] ?? 5) - (priorityOrder[b.priority] ?? 5);
    if (priorityDelta) return priorityDelta;
    if (Boolean(a.overdue) !== Boolean(b.overdue)) return a.overdue ? -1 : 1;
    const dueDelta = dueTime(a.due_date) - dueTime(b.due_date);
    if (dueDelta) return dueDelta;
    return String(b.updated_at || "").localeCompare(String(a.updated_at || ""));
  });
}

function goalMetrics(tasks) {
  return {
    active: tasks.length,
    overdue: tasks.filter((task) => task.overdue).length,
    blocked: tasks.filter((task) => task.status === "阻塞").length,
  };
}

export function buildWorkBlockExecution(data, showArchived = false) {
  const tasks = data?.tasks || [];
  const projects = data?.projects || [];
  const blocks = (data?.work_blocks || []).filter(
    (block) => Boolean(block.archived) === Boolean(showArchived),
  );

  return blocks.map((block, index) => {
    const executionTasks = sortExecutionTasks(
      tasks.filter(
        (task) =>
          task.work_block_id === block.id && !terminalStatuses.has(task.status),
      ),
    );
    const blockProjects = projects.filter(
      (project) =>
        project.work_block_id === block.id && !Boolean(project.archived),
    );
    const directTasks = executionTasks.filter((task) => !task.project_id);
    const projectGoals = blockProjects.map((project) => {
      const projectTasks = executionTasks.filter(
        (task) => task.project_id === project.id,
      );
      return {
        id: project.id,
        name: project.name,
        owner_name: project.owner_name || null,
        status: project.status || "待确认",
        result:
          project.week_goal ||
          project.next_milestone ||
          project.description ||
          "目标结果待确认",
        next_milestone: project.next_milestone || null,
        evidence: project.evidence || null,
        metrics: goalMetrics(projectTasks),
      };
    });
    const directGoal =
      directTasks.length || projectGoals.length === 0
        ? [
            {
              id: `${block.id}-direct-goal`,
              name: projectGoals.length ? "工作块直属目标" : "本周核心目标",
              owner_name: block.owner_name || null,
              status: block.health || "待确认",
              result:
                block.week_goal ||
                block.next_milestone ||
                block.description ||
                "目标结果待确认",
              next_milestone: block.next_milestone || null,
              evidence: block.evidence || null,
              metrics: goalMetrics(directTasks),
            },
          ]
        : [];

    return {
      ...block,
      displayIndex: String(index + 1).padStart(2, "0"),
      executionTasks,
      executionGoals: [...projectGoals, ...directGoal],
      activeP0: executionTasks.filter((task) => task.priority === "P0").length,
      activeP1: executionTasks.filter((task) => task.priority === "P1").length,
    };
  });
}

export function getPriorityWorkBlocks(blocks = [], limit = 3) {
  return [...blocks]
    .filter((block) => block.activeP0 > 0)
    .sort(
      (a, b) =>
        b.activeP0 - a.activeP0 ||
        b.metrics.overdue - a.metrics.overdue ||
        a.displayIndex.localeCompare(b.displayIndex),
    )
    .slice(0, limit);
}
